import { useQuery } from "@tanstack/react-query";
import { getWarehouseOptions } from "services/data.internal.service";

export const useWhOptionsQuery = ({ onSuccess }) => {
  return useQuery({
    queryKey: ["warehouse-options"],
    queryFn: () => getWarehouseOptions(),
    onSuccess,
  });
}